'use strict';

// TODO: consider changing auditlog schema to allow for key retrieval

import { findIndex, get, lowerCase } from 'lodash';

export function getValueFromAuditLogByKey({ auditLogEntry, key }) {
  const index = findIndex(get(auditLogEntry, 'entityNames', []), name => name === key);
  // key not found
  if (index === -1) return;

  return get(auditLogEntry, `entityIds.${index}`);
}

/**
 * Returns the TSG key stored in an audit log entry, or undefined if not present.
 * Entries are stored as e.g. "toolStoreGroupKey[0]".
 */
export function getTsgKeyFromAuditEntry(auditLogEntry) {
  return getValueFromAuditLogByKey({ auditLogEntry, key: 'toolStoreGroupKey[0]' });
}

/**
 * Returns true when the audit log entry stores the given flag key with the string value 'true'
 * (case-insensitive). Returns false for any other value, a missing key, or undefined.
 */
export function isAuditLogFlagTrue({ auditLogEntry, key }) {
  const value = getValueFromAuditLogByKey({ auditLogEntry, key });
  return lowerCase(value) === 'true';
}

export default getValueFromAuditLogByKey;
